module.exports = __webpack_public_path__ + "img/17.965a0efe.jpg";